<template>
  <section v-if="!completedUserFlow" class="nav-item-container mb-4">
    <FinancialAdvisorProUpsellButton
      v-if="shouldShowIconOnly"
      :text="$t('nav.discover-pro')"
      :force-icon-on-small-screens="true"
    />
    <div
      v-else
      class="card is-radius-large m-3 has-shadow is-flex-centered is-flex-direction-column p-4"
    >
      <img src="@/assets/illustrations/launch-rocket.svg" width="46" />
      <div
        class="is-flex-centered is-flex-direction-column is-size-6"
        :data-e2e="FinancialAdvisorEstateCypressAttribute.nav.views.ADVISOR_PRO_UPGRADE_CONTENT"
      >
        <span class="is-size-5 has-text-weight-semibold mt-3">
          {{ $t('nav.upgrade-to-advisor-pro') }}
        </span>
        <span class="mt-3 has-text-centered">{{ $t('nav.take-your-advisory-practice') }}</span>
        <div class="is-flex is-flex-direction-row mt-3">
          <ButtonView
            id="not-interested-btn"
            class="is-size-6 has-text-weight-semibold"
            type="is-ghost"
            @click="onNotInterestedClicked"
            :data-e2e="
              FinancialAdvisorEstateCypressAttribute.nav.buttons
                .ADVISOR_PRO_UPGRADE_NOT_INTERESTED_BUTTON
            "
          >
            {{ $t('nav.not-interested') }}
          </ButtonView>

          <FinancialAdvisorProUpsellButton
            :text="$t('nav.discover-pro')"
            custom-class="is-size-6 has-text-weight-semibold"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { HasResizeHandlerMixin } from '@/modules/core/app/mixins/HasResizeHandlerMixin';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { DeviceBreakpoint } from '@/modules/core/ui/enums/DeviceBreakpoint';
import FinancialAdvisorProUpsellButton from '@/modules/financialadvisor/components/presentational/FinancialAdvisorProUpsellButton.vue';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute.js';
import { UserFlowAdvisorProUpgradeFlowValue } from '@/modules/user/constants/UserFlowAdvisorProUpgradeFlowValue';
import { UserFlowType } from '@/modules/user/constants/UserFlowType';
import { UserFlow } from '@/modules/user/models/UserFlow';
import UserFlowService from '@/modules/user/services/UserFlowService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinancialAdvisorAdvisorProUpgradeNavItem',
  mixins: [HasResizeHandlerMixin, HasAuthUserMixin],
  components: {
    ButtonView,
    FinancialAdvisorProUpsellButton
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  static: {
    FinancialAdvisorEstateCypressAttribute
  },
  data() {
    return {
      completedUserFlow: null
    };
  },
  computed: {
    shouldShowIconOnly() {
      return this.windowWidth <= DeviceBreakpoint.DESKTOP;
    }
  },
  methods: {
    async onNotInterestedClicked() {
      this.completedUserFlow = await UserFlowService.saveEntity(
        UserFlow.mapModel({
          userId: this.authUser.id,
          estateId: null,
          type: UserFlowType.ADVISOR_PRO_UPGRADE_FLOW,
          currentValue: UserFlowAdvisorProUpgradeFlowValue.NOT_INTERESTED,
          isComplete: true
        })
      );
    }
  }
};
</script>

<style scoped>
:deep(.button) {
  height: var(--ce-32px);
  padding: var(--ce-8px);
}

#not-interested-btn:hover {
  box-shadow: none;
}
</style>
